import React from "react";
import ProgramDetailsSection from "../../../../components/template/ProgramDetailSection";

const Invision = () => {
  return (
    <ProgramDetailsSection
      title="INVISION"
      tagline="Leadership Excellence Workshop"
      highlights={[
        "Science-Based",
        "Deep Reflection & Dialogue",
        "Culture & Legacy Focused",
      ]}
      description="INVISION develops exceptional leaders who inspire people, nurture culture, and create long-term organizational and societal impact through purposeful leadership."
      duration="1.5 Days"
      focusAreas={[
        "Holistic Wellbeing & Leadership Presence",
        "Team Nurturing & Motivation",
        "Mentoring & People Development",
        "Culture Building & Organizational Excellence",
        "Purposeful Leadership & Contribution",
      ]}
      outcomes={[
        "Develop the mindset and capabilities to inspire, nurture, and elevate others.",
        "Strengthen the culture, values, and human foundations that drive long-term success.",
        "Expand leadership impact from achieving results to creating lasting organizational and societal value.",
      ]}
      images={[
         "../../../cw/CW12.JPG",
          "../../../cw/CW14.JPG",
      ]}
    />
  );
};

export default Invision;